// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectBox_wrapper__WlJUz","select":"SelectBox_select__ExuOE","arrow":"SelectBox_arrow__Jh1UL"};